// extracted by mini-css-extract-plugin
export default {"container":"btyVgQIt4J5elRAgbrjw","title":"NsGuIRq3_9NvnY6MHPo2","body":"Bs1UlzaBc0m09ENDisNW"};